import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../styles/I3Layout.css';

const NAV_LINKS = [
  { to: '/', label: 'Home' },
  { to: '/about', label: 'About' },
  { to: '/services', label: 'Services' },
  { to: '/events', label: 'Events' },
  { to: '/blog', label: 'Journal' },
  { to: '/contact', label: 'Contact' },
];

const I3Nav: React.FC = () => {
  const location = useLocation();
  const pathname = location.pathname;

  const navLinkClass = (to: string): string => {
    if (pathname === to) return 'active';
    const base = '/';
    if (to === base) return pathname === base || pathname === `${base}/` ? 'active' : '';
    return pathname.startsWith(`${to}/`) ? 'active' : '';
  };

  return (
    <nav className="i3-nav i3-nav--over-video" aria-label="Primary">
      <div className="i3-nav-inner">
        <ul className="i3-nav-links">
          {NAV_LINKS.map(({ to, label }) => (
            <li key={to}>
              <Link
                to={to}
                className={navLinkClass(to)}
              >
                {label}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};

export default I3Nav;
